angular.module('acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionOutputDownloadModalController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.view.application.importExport.exportJobExecution.directives.exportJobExecutionOutputs',
])
.controller('ExportJobExecutionOutputDownloadModalController', ExportJobExecutionOutputDownloadModalController);

/**
 * Controller responsible for showing the user the downloadable Outputs for a Export Job Execution
 * @class ExportJobExecutionOutputDownloadModalController
 * @constructor
 * @return {ExportJobExecutionOutputDownloadModalController} - Class instance
 */
function ExportJobExecutionOutputDownloadModalController($uibModalInstance, reportName, executionId, outputs) {
  Object.assign(this, {
    $uibModalInstance: $uibModalInstance,
    reportName: reportName,
    executionId: executionId,
    outputs: outputs
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ExportJobExecutionOutputDownloadModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
};

ExportJobExecutionOutputDownloadModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    reportName = _data.reportName || '',
    executionId = _data.executionId || '',
    outputs = _data.outputs || [];

  return {
    reportName: reportName,
    executionId: executionId,
    outputs: outputs
  };
};

ExportJobExecutionOutputDownloadModalController.prototype.done = function () {
  this.$uibModalInstance.dismiss();
};

ExportJobExecutionOutputDownloadModalController.$inject = [
  '$uibModalInstance',
  'reportName',
  'executionId',
  'outputs'
];
